import type {SearchCriteriaRaw} from '../../../types';
import {createFileFormatRule} from '../fileFormatRule';
import type {FileFormatRule, TSearchTypeFileFormat} from '../types';

export type RawFileFormatSearchCriteria =
	SearchCriteriaRaw<TSearchTypeFileFormat>;

export const rawFileFormatCriteriaToRuleObject = (
	criteria: RawFileFormatSearchCriteria,
): FileFormatRule => {
	return createFileFormatRule({
		type: criteria.subtype1,
		fileFormat: criteria.value1,
	});
};

export default rawFileFormatCriteriaToRuleObject;
